import { render } from "./UserFeed.vue?vue&type=template&id=0619bc7e&scoped=true"
import script from "./UserFeed.vue?vue&type=script&lang=js"
export * from "./UserFeed.vue?vue&type=script&lang=js"

import "./UserFeed.vue?vue&type=style&index=0&id=0619bc7e&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0619bc7e"]])

export default __exports__